module.exports = __webpack_public_path__ + "static/media/emgeaGreenIcon.402ecd2d.svg";